export var SituacaoRequerimentoEnum;
(function (SituacaoRequerimentoEnum) {
    SituacaoRequerimentoEnum["PREENCHIMENTO_EM_ABERTO"] = "PREENCHIMENTO_EM_ABERTO";
    SituacaoRequerimentoEnum["SUSPENSO"] = "SUSPENSO";
    SituacaoRequerimentoEnum["TAXAS_EMITIDAS"] = "TAXAS_EMITIDAS";
    SituacaoRequerimentoEnum["TAXAS_VENCIDAS"] = "TAXAS_VENCIDAS";
    SituacaoRequerimentoEnum["TAXAS_PENDENTES"] = "TAXAS_PENDENTES";
    SituacaoRequerimentoEnum["TAXAS_PAGAS"] = "TAXAS_PAGAS";
    SituacaoRequerimentoEnum["PREENCHIMENTO_FINALIZADO"] = "PREENCHIMENTO_FINALIZADO";
    SituacaoRequerimentoEnum["VERIFICACAO_DOCUMENTAL"] = "VERIFICACAO_DOCUMENTAL";
    SituacaoRequerimentoEnum["PENDENCIAS_DOCUMENTAIS"] = "PENDENCIAS_DOCUMENTAIS";
    SituacaoRequerimentoEnum["ATENDIMENTO_PRIORITARIO"] = "ATENDIMENTO_PRIORITARIO";
    SituacaoRequerimentoEnum["ISENTO_TAXAS"] = "ISENTO_TAXAS";
    SituacaoRequerimentoEnum["CONCLUIDO"] = "CONCLUIDO";
})(SituacaoRequerimentoEnum || (SituacaoRequerimentoEnum = {}));
(function (SituacaoRequerimentoEnum) {
    var mapDescricao = new Map([
        [SituacaoRequerimentoEnum.PREENCHIMENTO_EM_ABERTO, 'Preenchimento em Aberto'],
        [SituacaoRequerimentoEnum.SUSPENSO, 'Suspenso'],
        [SituacaoRequerimentoEnum.TAXAS_EMITIDAS, 'Taxas Emitidas'],
        [SituacaoRequerimentoEnum.TAXAS_VENCIDAS, 'Taxas Vencidas'],
        [SituacaoRequerimentoEnum.PREENCHIMENTO_FINALIZADO, 'Preenchimento Finalizado'],
        [SituacaoRequerimentoEnum.VERIFICACAO_DOCUMENTAL, 'Verificação Documental'],
        [SituacaoRequerimentoEnum.PENDENCIAS_DOCUMENTAIS, 'Em diligência'],
        [SituacaoRequerimentoEnum.ATENDIMENTO_PRIORITARIO, 'Atendimento Prioritario'],
        [SituacaoRequerimentoEnum.TAXAS_PENDENTES, 'Taxas Pendentes'],
        [SituacaoRequerimentoEnum.TAXAS_PAGAS, 'Taxas Pagas'],
        [SituacaoRequerimentoEnum.ISENTO_TAXAS, 'Isento de Taxas'],
        [SituacaoRequerimentoEnum.CONCLUIDO, 'Concluído'],
    ]);
    function getDescricao(status) {
        return mapDescricao.get(status);
    }
    SituacaoRequerimentoEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    SituacaoRequerimentoEnum.getOptions = getOptions;
})(SituacaoRequerimentoEnum || (SituacaoRequerimentoEnum = {}));
